import Nullstack from 'nullstack';
export default function IconPlaylistAdd({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-playlist-add",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19 8h-14"
  }), "   ", Nullstack.element("path", {
    d: "M5 12h9"
  }), "   ", Nullstack.element("path", {
    d: "M11 16h-6"
  }), "   ", Nullstack.element("path", {
    d: "M15 16h6"
  }), "   ", Nullstack.element("path", {
    d: "M18 13v6"
  }), " ");
}